import React from 'react';

export default function CancelOrderSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="69" height="76" viewBox="0 0 69 76">
      <g fill="none">
        <path
          fill="#FACDCA"
          d="M51.785 76H4.215C1.72 76-.23 73.883.023 71.446l5.273-50.87C5.622 17.409 8.34 15 11.585 15h32.832c3.243 0 5.962 2.409 6.29 5.576l5.27 50.87C56.232 73.883 54.282 76 51.786 76"
        />
        <path
          fill="#FFAFAD"
          d="M45.957 69H12.042c-1.273 0-2.236-1.337-2.009-2.787l1.3-8.272C11.51 56.815 12.357 56 13.344 56h31.314c.987 0 1.833.815 2.01 1.94l1.3 8.273c.227 1.45-.736 2.787-2.01 2.787"
        />
        <path
          fill="#F1726B"
          d="M41.686 71.314c-6.248-6.248-6.248-16.379 0-22.628 6.249-6.248 16.38-6.248 22.628 0 6.248 6.25 6.248 16.38 0 22.628-6.249 6.248-16.38 6.248-22.628 0"
        />
        <path
          fill="#FFF"
          d="M39.116 22c2.312 0 4.186 1.833 4.186 4.095 0 2.262-1.874 4.095-4.186 4.095-2.311 0-4.186-1.833-4.186-4.095 0-2.262 1.875-4.095 4.186-4.095zm-20.93 0c2.312 0 4.186 1.833 4.186 4.095 0 2.262-1.874 4.095-4.186 4.095S14 28.357 14 26.095C14 23.833 15.874 22 18.186 22zm35.581 39.329L50.321 64.7c-.204.2-.472.3-.74.3s-.536-.1-.74-.3c-.409-.4-.409-1.047 0-1.448l3.446-3.371-3.446-3.371c-.409-.4-.409-1.048 0-1.448.41-.4 1.07-.4 1.48 0l3.446 3.371 3.446-3.371c.41-.4 1.07-.4 1.48 0 .41.4.41 1.047 0 1.448l-3.446 3.371 3.446 3.371c.41.4.41 1.048 0 1.448-.204.2-.472.3-.74.3s-.536-.1-.74-.3l-3.446-3.371z"
        />
        <path
          fill="#7992A5"
          d="M37.917 29c-1.15 0-2.084-.962-2.084-2.148V12.889c0-4.738-3.737-8.593-8.333-8.593-4.595 0-8.333 3.855-8.333 8.593v13.963c0 1.186-.934 2.148-2.084 2.148S15 28.038 15 26.852V12.889C15 5.782 20.607 0 27.5 0S40 5.782 40 12.889v13.963C40 28.038 39.067 29 37.917 29"
        />
      </g>
    </svg>
  );
}

CancelOrderSvg.displayName = 'CancelOrderSvg';
